import React from 'react';
export default class ElegantResumeEducation extends React.Component{

    getResumeBlock(data, index){
        let title = [];
        if (data.degree){
            //title.push(<span key="a" data-v-b8233322="">{data.degree}</span>)
        }

        if (data.schoolName){
            title.push(<span key="b" data-v-5a80631c="">{data.schoolName}</span>)
        }

        let titleFinal = [];
        for(let i = 0; i < title.length; i++){
            titleFinal.push(title[i]);
            if(i + 1 < title.length){
                titleFinal.push(<span key={i}  data-v-b8233322="" className="comma">, </span>)
            }
        }

        return  <div data-v-5a80631c="" className="section-item" key={index}>
                    <div data-v-5a80631c="" className="section-meta">{titleFinal}</div>
                    
					{data.endDate && data.startDate && <div data-v-5a80631c="" className="section-title">
								<b data-v-5a80631c="">{data.degree}</b><span data-v-5a80631c="">/</span><span className="date" data-v-5a80631c="">{data.startDate.toUpperCase()} -</span>
                        <span className="date" data-v-5a80631c="">{data.endDate.toUpperCase()}</span> </div>}
								
					<div data-v-5a80631c="" className="section-description" dangerouslySetInnerHTML={{ __html: data.description }}></div>
                </div>
    }

    render(){
        return  <div data-v-5a80631c="" className="section">
                    <div data-v-5a80631c="" className="section-headline">{this.props.title}</div>
                    {this.props.data.map((item, index) => {
                        return this.getResumeBlock(item, index);
                    })}
                </div>

    }
}